// extracted by mini-css-extract-plugin
export default {"main":"personalInfo_main__CH4sb","line":"personalInfo_line__V4dOv","marginTop":"personalInfo_marginTop__G-3So","marginBottom":"personalInfo_marginBottom__YS6za"};